import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { cloneDeep } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useGradingGroupState } from './GradingGroupProvider';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import CustomTooltip from '../../../../Components/Tooltip/CustomTooltip';
import expandIcon from '../../../../assets/icons/expand.svg';
import collapseIcon from '../../../../assets/icons/collapse.svg';
import minusIcon from '../../../../assets/icons/minus.svg';
import addIcon from '../../../../assets/icons/add.svg';

function SizeRangeGrading() {
  const { gradingGroupState, setgradingGroup, foundReferences, GradingAddEditAccess } = useGradingGroupState();
  const { t } = useTranslation('common');
  const [isExpanded, setIsExpanded] = useState(true);

  const { sizeRanges, isView } = gradingGroupState;

  const selectedSampleSize = sizeRanges?.find((item) => item.isSampleSize);
  const handleAddInputBox = (side) => {
    const cloneArray = [...sizeRanges];
    if (side === 'left') {
      if (foundReferences) {
        cloneArray.unshift({ name: '', isSampleSize: false, modificationAllowed: true });
      } else {
        cloneArray.unshift({ name: '', isSampleSize: false });
      }
    } else if (side === 'right') {
      if (foundReferences) {
        cloneArray.push({ name: '', isSampleSize: false, modificationAllowed: true });
      } else {
        cloneArray.push({ name: '', isSampleSize: false });
      }
    }
    setgradingGroup((prev) => ({
      ...prev,
      sizeRanges: cloneArray,
    }));
  };

  const handleRemoveInputBox = (side) => {
    const cloneArray = [...sizeRanges];
    if (foundReferences) {
      console.log('🚀 ~ handleRemoveInputBox ~ foundReferences:', foundReferences);
      const newAddSample = cloneArray?.filter((item1) => {
        const match = gradingGroupState?.sampleSize.find((item2) => item1.name === item2.name);
        return !match;
      });
      if (side === 'left') {
        const filterData = newAddSample?.filter((data) => data.name === cloneArray[0]?.name);
        if (filterData.length) {
          cloneArray.shift({ name: '', isSampleSize: false });
        }
      } else if (side === 'right') {
        const filterData = newAddSample?.filter((data) => data.name === cloneArray[cloneArray.length - 1]?.name);
        if (filterData.length) {
          cloneArray.pop({ name: '', isSampleSize: false });
        }
      }
      setgradingGroup((prev) => ({
        ...prev,
        sizeRanges: cloneArray,
      }));
    } else if (sizeRanges.length - 1 !== 0) {
      if (side === 'left') {
        cloneArray.shift({ name: '', isSampleSize: false });
      } else if (side === 'right') {
        cloneArray.pop({ name: '', isSampleSize: false });
      }
      setgradingGroup((prev) => ({
        ...prev,
        sizeRanges: cloneArray,
      }));
    }
  };

  const handleInputChange = (index, fieldName, value) => {
    const updatedSizeRanges = sizeRanges?.map((item, i) => {
      if (i === index) {
        return {
          ...item,
          [fieldName]: value,
        };
      }
      return item;
    });

    setgradingGroup((prev) => ({
      ...prev,
      sizeRanges: updatedSizeRanges,
    }));
  };

  const handleRadioChange = (index, checked) => {
    const updatedData = sizeRanges?.map((item, i) => (i === index ? { ...item, isSampleSize: checked } : { ...item, isSampleSize: false }));
    setgradingGroup((prev) => ({
      ...prev,
      sizeRanges: updatedData,
    }));
  };

  const arraysEqual = (arrOld, arrNew) => {
    const tempObj = {
      isLengthChanged: false,
      isNameChanged: false,
      isSampleSizeSelectionChanged: false,
      doNotCheck: false,
    };

    if (arrOld.length > 0) {
      if (arrOld.length > arrNew.length) {
        tempObj.isLengthChanged = true;
      } else if (arrOld.length < arrNew.length) {
        tempObj.isLengthChanged = true;
      } else {
        tempObj.isLengthChanged = false;
      }
      for (let i = arrOld.length; i--; ) {
        if (arrOld[i] && arrNew[i]) {
          tempObj.isNameChanged = arrOld[i].sizeName !== arrNew[i].sizeName;

          if (tempObj.isNameChanged) break;
        }
      }
      for (let i = arrOld.length; i--; ) {
        if (arrOld[i] && arrNew[i]) {
          tempObj.isSampleSizeSelectionChanged = arrOld[i].isSampleSize !== arrNew[i].isSampleSize;
          if (tempObj.isSampleSizeSelectionChanged) break;
        }
      }

      return tempObj;
    }
    tempObj.doNotCheck = true;
    return tempObj;
  };

  const applySizeRangesToHeader = (sizeRangesValue) => {
    return sizeRangesValue.map((item) => ({
      sizeName: item.name,
      isSampleSize: item.isSampleSize,
      isZero: !!item.isSampleSize,
    }));
  };

  const updatePomTableDataIfNameChanged = (pomTableData, rangeValue) => {
    const updatedArray = cloneDeep(pomTableData);

    // eslint-disable-next-line no-restricted-syntax
    for (const item of updatedArray) {
      // Remove gradings not found in rangeValue
      item.gradings = item.gradings.filter((grading) => rangeValue.some((range) => range.sizeName === grading.sizeName));

      // Add missing gradings at the correct index
      rangeValue.forEach((range, idx) => {
        console.log('🚀 ~ file: SizeRangeGrading.jsx:150 ~ rangeValue.forEach ~ range:', range);
        const found = item.gradings.some((grading) => grading.sizeName === range.sizeName);
        if (!found) {
          item.gradings.splice(idx, 0, { sizeName: range.sizeName, isSampleSize: range.isSampleSize, grading: '0', isZero: range.isSampleSize });
        }
      });
    }
    console.log('🚀 ~  ~ updatePomTableDataIfNameChanged ~ updatedArray:', updatedArray);

    setgradingGroup((prev) => ({
      ...prev,
      pomTableData: updatedArray,
    }));
  };

  const updatePomTableDataIfSampleChanged = (pomTableData, rangeValue) => {
    const index = rangeValue.findIndex((item) => item.isSampleSize === true);

    const updatedArray = pomTableData?.map((item) => {
      const updatedGrading = item.gradings.map((grading, i) => {
        if (i === index) {
          return { ...grading, isSampleSize: true, isZero: true };
        }
        return { ...grading, isSampleSize: false, isZero: false };
      });
      console.log('🚀 ~ file: SizeRangeGrading.jsx:175 ~ updatedArray:', updatedGrading);
      return { ...item, gradings: updatedGrading };
    });
    console.log('🚀 ~ file: SizeRangeGrading.jsx:178 ~ updatedArray:', updatedArray);
    setgradingGroup((prev) => ({
      ...prev,
      pomTableData: updatedArray,
    }));
  };

  const updatePomTableDataIfNameAndSampleChanged = (pomTableData, rangeValue) => {
    const updatedArray = pomTableData?.map((item) => {
      // First filter gradings to match rangeValue sizes
      const newGradings = rangeValue.map((range) => {
        const existingGrading = item.gradings.find((grading) => grading.sizeName === range.sizeName);
        return {
          sizeName: range.sizeName,
          isSampleSize: range.isSampleSize,
          isZero: range.isSampleSize,
          grading: existingGrading?.grading || '0',
        };
      });
      console.log('🚀 ~ newGradings ~ newGradings:', newGradings);

      return { ...item, gradings: newGradings };
    });

    setgradingGroup((prev) => ({
      ...prev,
      pomTableData: updatedArray,
    }));
  };

  const updatePomTableDataisLengthChanged = (pomTableData, rangeValue) => {
    const updatedArray = pomTableData.map((item) => {
      const newGradings = rangeValue?.map((headerItem) => {
        const gradingItem = item?.gradings?.find((grading) => grading?.sizeName === headerItem?.sizeName);
        return {
          sizeName: headerItem?.sizeName,
          isSampleSize: headerItem?.isSampleSize,
          isZero: headerItem?.isZero,
          grading: gradingItem?.grading ? gradingItem?.grading : 0, // Set to 0 if not found
        };
      });
      console.log('🚀 ~ file: SizeRangeGrading.jsx:195 ~ updatedArray:', newGradings);
      return {
        ...item,
        gradings: newGradings,
      };
    });
    console.log('🚀 ~ file: SizeRangeGrading.jsx:201 ~ updatedArray:', updatedArray);
    setgradingGroup((prev) => ({
      ...prev,
      pomTableData: updatedArray,
    }));
  };

  const conditionIfPomDataExist = (rangeValue) => {
    const objDiff = arraysEqual(gradingGroupState?.sizeRangesForHeader, rangeValue);
    console.log('🚀 ~ file: SizeRangeGrading.jsx:210 ~ conditionIfPomDataExist ~ objDiff:', objDiff);
    if (!objDiff?.isLengthChanged && objDiff?.isNameChanged && !objDiff?.isSampleSizeSelectionChanged) {
      updatePomTableDataIfNameChanged(gradingGroupState?.pomTableData, rangeValue);
    }
    if (!objDiff?.isLengthChanged && !objDiff?.isNameChanged && objDiff?.isSampleSizeSelectionChanged) {
      updatePomTableDataIfSampleChanged(gradingGroupState?.pomTableData, rangeValue);
    }
    if (!objDiff?.isLengthChanged && objDiff?.isNameChanged && objDiff?.isSampleSizeSelectionChanged) {
      updatePomTableDataIfNameAndSampleChanged(gradingGroupState?.pomTableData, rangeValue);
    }
    if (objDiff.isLengthChanged) {
      updatePomTableDataisLengthChanged(gradingGroupState?.pomTableData, rangeValue);
    }
  };

  const handleApplyButton = () => {
    const sizeRangeValue = cloneDeep(sizeRanges);
    const rangeValue = applySizeRangesToHeader(sizeRangeValue);
    const validSizeRange = sizeRanges.filter((item) => !item?.name);

    if (!validSizeRange?.length) {
      const arrSampleSizeNotSet = sizeRanges?.filter((value) => !value?.isSampleSize);
      if (sizeRanges?.length === arrSampleSizeNotSet?.length) {
        toasterMsg(t('POMS.GRADING_GROUP.SIZE_RANGE_GRADING.PLEASE_SIZE_RANGE'), 'danger');
      }
      const valueArr = sizeRanges?.map((item) => item?.name);
      const isDuplicate = valueArr?.some((item, idx) => valueArr?.indexOf(item) !== idx);
      if (isDuplicate) {
        toasterMsg(t('POMS.GRADING_GROUP.SIZE_RANGE_GRADING.UNIQUE_SIZE_RANGE'), 'danger');
      } else {
        setgradingGroup((prev) => ({
          ...prev,
          sizeRangesForHeader: rangeValue,
          applySizeRangesToHeaderText: true,
        }));

        if (gradingGroupState?.pomTableData.length > 0) {
          conditionIfPomDataExist(rangeValue);
        }
      }
    } else {
      toasterMsg(t('POMS.GRADING_GROUP.SIZE_RANGE_GRADING.ENTER_SIZE_RANGE'), 'danger');
    }
  };

  return (
    <Container className="mt-24" fluid>
      <div className="size-grading">
        {isExpanded ? (
          <>
            <span className="f-16 text-bold mr-1">{t('POMS.GRADING_GROUP.SIZE_RANGE_GRADING.SIZES') || t('COMMON_LABEL.SIZE') || 'Sizes'}</span>
            <button
              type="button"
              className="btn p-0 mr-16"
              onClick={() => setIsExpanded(false)}
              disabled={isView || !GradingAddEditAccess}
              aria-label={t('POMS.GRADING_GROUP.SIZE_RANGE_GRADING.COLLAPSE') || 'Collapse'}
            >
              <img src={`${isExpanded ? collapseIcon : expandIcon}`} alt="expand/collapse" />
            </button>
            <button
              aria-label="remove"
              className="btn btn-minus size-btn mr-8"
              onClick={() => handleRemoveInputBox('left')}
              type="button"
              disabled={isView || !GradingAddEditAccess}
            >
              <img src={minusIcon} alt="minus" />
            </button>
            <button
              onClick={() => {
                handleAddInputBox('left');
              }}
              className="btn btn-add size-btn mr-16"
              type="button"
              aria-label={t('COMMON_LABEL.ADD')}
              disabled={isView || !GradingAddEditAccess}
            >
              <img src={addIcon} alt="minus" />
            </button>
            <div className="size-input-container">
              {foundReferences
                ? sizeRanges?.map((item, index) => (
                    <div key={index} className="d-flex align-items-center  position-relative mr-8">
                      <p className="custom-radio style-green sm mb-0 mr-8">
                        <input
                          id={`status_${index}_${item?.name}`}
                          type="radio"
                          name="SampleSize"
                          className="ml-8 sample-size-radio"
                          checked={item?.isSampleSize}
                          value={item?.isSampleSize}
                          onChange={(e) => handleRadioChange(index, e.target.checked)}
                          disabled={foundReferences || !GradingAddEditAccess}
                        />
                        <label htmlFor={`status_${index}_${item?.name}`} />
                      </p>
                      <input
                        type="text"
                        value={item?.name || ''}
                        className={`form-control size-input ${item?.isSampleSize || item?.isZero ? 'sample-size-input' : ''}`}
                        onChange={(e) => handleInputChange(index, 'name', e.target.value.trimStart())}
                        disabled={!item.modificationAllowed || !GradingAddEditAccess}
                        placeholder={t('POMS.GRADING_GROUP.SIZE_RANGE_GRADING.SIZE_RANGE')}
                      />
                    </div>
                  ))
                : sizeRanges?.map((item, index) => (
                    <div key={index} className="d-flex align-items-center position-relative mr-8">
                      <p className="custom-radio style-green sm mb-0 mr-8">
                        <input
                          id={`status_${index}_${item?.name}`}
                          type="radio"
                          name="SampleSize"
                          className="ml-8 sample-size-radio"
                          checked={item.isSampleSize}
                          value={item.isSampleSize}
                          onChange={(e) => handleRadioChange(index, e.target.checked)}
                          disabled={foundReferences || !GradingAddEditAccess}
                        />
                        <label htmlFor={`status_${index}_${item?.name}`} />
                      </p>
                      <input
                        type="text"
                        value={item.name || ''}
                        className={`form-control size-input ${item?.isSampleSize || item?.isZero ? 'sample-size-input' : ''}`}
                        onChange={(e) => handleInputChange(index, 'name', e.target.value.trimStart())}
                        disabled={!GradingAddEditAccess}
                        placeholder={t('POMS.GRADING_GROUP.SIZE_RANGE_GRADING.SIZE_RANGE')}
                      />
                    </div>
                  ))}
            </div>
            <button
              className="btn btn-minus size-btn ml-8 mr-8"
              aria-label={t('COMMON_LABEL.REMOVE')}
              onClick={() => handleRemoveInputBox('right')}
              type="button"
              disabled={isView || !GradingAddEditAccess}
            >
              <img src={minusIcon} alt="minus" />
            </button>
            <button
              onClick={() => {
                handleAddInputBox('right');
              }}
              className="btn btn-add size-btn mr-8"
              type="button"
              aria-label={t('COMMON_LABEL.ADD')}
              disabled={isView || !GradingAddEditAccess}
            >
              <img src={addIcon} alt="add" />
            </button>
            <CustomTooltip tooltipText={t('POMS.GRADING_GROUP.SIZE_RANGE_GRADING.APPLY')}>
              <button
                aria-label="apply"
                className="btn btn-save size-btn mr-0"
                type="button"
                onClick={handleApplyButton}
                disabled={isView || !GradingAddEditAccess}
              >
                <i className="icon-Save-1 f-18" />
              </button>
            </CustomTooltip>
          </>
        ) : (
          <div className="d-flex align-items-center">
            <span className="f-16 text-bold mr-1">{t('POMS.GRADING_GROUP.SIZE_RANGE_GRADING.SIZES') || t('COMMON_LABEL.SIZE') || 'Sizes'}</span>
            <button
              type="button"
              className="btn p-0 mr-16"
              onClick={() => setIsExpanded(true)}
              disabled={isView || !GradingAddEditAccess}
              aria-label={t('POMS.GRADING_GROUP.SIZE_RANGE_GRADING.EXPAND') || 'Expand'}
            >
              <img src={expandIcon} alt="expand" />
            </button>
            {selectedSampleSize?.name && <span className="sample-size-span">{selectedSampleSize.name}</span>}
          </div>
        )}
      </div>
    </Container>
  );
}

export default SizeRangeGrading;
